// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// // Import the specific API call function from your httpservice
// import { signupUser as apiSignupUser, loginUser as apiLoginUser, getMyProfile } from '../../Common/services/httpservice'; // Adjusted import


// // Helper to get user info from localStorage
// const getUserInfoFromStorage = () => {
//     // This helper loads the user profile object.
//     try {
//         const userInfoString = localStorage.getItem('userInfo'); // Key for user profile object
//         return userInfoString ? JSON.parse(userInfoString) : null;
//     } catch (error) {
//         console.error("Error parsing userInfo from localStorage", error);
//         localStorage.removeItem('userInfo'); // Clear corrupted item
//         return null;
//     }
// };

// // Async thunk for user signup
// export const signupUser = createAsyncThunk(
//     'auth/signupUser',
//     async (userData, { rejectWithValue }) => {
//         try {
//             // Use the imported signupUser function from httpservice.js
//             // Assume API response 'data' is like { token: "...", user: { ... } } or { token: "...", ...otherUserDetails }
//             const data = await apiSignupUser(userData);
//             if (data && data.token) {
//                 localStorage.setItem('authToken', data.token); // Key for isAuthenticated
//                 localStorage.setItem('userInfo', JSON.stringify(data.user || data)); // Store user part or whole data
//             }
//             return data; // Full response is passed to fulfilled reducer
//         } catch (error) {
//             if (error.message) {
//                 return rejectWithValue(error.message);
//             } else {
//                 return rejectWithValue('An unknown error occurred during signup.');
//             }
//         }
//     }
// );

// // Async thunk for user login
// export const loginUser = createAsyncThunk(
//     'auth/loginUser',
//     async (loginData, { rejectWithValue }) => {
//         try {
//             // Step 1: Get tokens from the login endpoint
//             const tokenData = await apiLoginUser(loginData); // Expects { access, refresh }

//             if (tokenData && tokenData.access) {
//                 localStorage.setItem('authToken', tokenData.access); // Store access token
//                 if (tokenData.refresh) {
//                     localStorage.setItem('refreshToken', tokenData.refresh); // Store refresh token
//                 }

//                 // Step 2: Fetch user profile using the access token
//                 const userProfile = await getMyProfile();
//                 localStorage.setItem('userInfo', JSON.stringify(userProfile)); // Store user profile

//                 return userProfile; // Return the user profile for the Redux state
//             } else {
//                 return rejectWithValue('Login failed: No access token received.');
//             }
//         } catch (error) {
//             // Clear tokens if login fails to prevent inconsistent state
//             localStorage.removeItem('authToken');
//             localStorage.removeItem('refreshToken');
//             localStorage.removeItem('userInfo');
//             if (error.message) {
//                 return rejectWithValue(error.message);
//             } else {
//                 return rejectWithValue('An unknown error occurred during login.');
//             }
//         }
//     }
// );


// const initialState = {
//     userInfo: getUserInfoFromStorage(), // Loads the user profile object
//     loading: false,
//     error: null,
//     signupMessage: null, // To store message from signup API
// };

// const authSlice = createSlice({
//     name: 'auth',
//     initialState,
//     reducers: {
//         logout: (state) => {
//             localStorage.removeItem('userInfo');
//             localStorage.removeItem('authToken'); // Ensure authToken is also cleared
//             state.userInfo = null;
//             state.loading = false;
//             state.error = null;
//         },
//         clearAuthError: (state) => {
//             state.error = null;
//         },
//         clearSignupMessage: (state) => {
//             state.signupMessage = null; // Corrected: should clear signupMessage
//         }
//     },
//     extraReducers: (builder) => {
//         builder
//             // Signup cases
//             .addCase(signupUser.pending, (state) => {
//                 state.loading = true;
//                 state.error = null;
//             })
//             .addCase(signupUser.fulfilled, (state, action) => {
//                 state.loading = false;
//                 // action.payload is the 'data' from thunk. Store user part in state.userInfo
//                 state.userInfo = action.payload.user; // Store only the user object
//                 state.signupMessage = action.payload.message; // Store the success message
//                 state.error = null;
//             })
//             .addCase(signupUser.rejected, (state, action) => {
//                 state.loading = false;
//                 state.error = action.payload; 
//                 state.userInfo = null;
//             })
//             // Login cases
//             .addCase(loginUser.pending, (state) => {
//                 state.loading = true;
//                 state.error = null;
//             })
//             .addCase(loginUser.fulfilled, (state, action) => {
//                 state.loading = false;
//                 // action.payload is now the userProfile object from the thunk
//                 state.userInfo = action.payload; 
//                 state.error = null;
//             })
//             .addCase(loginUser.rejected, (state, action) => {
//                 state.loading = false;
//                 state.error = action.payload;
//                 state.userInfo = null;
//             });
//     },
// });

// export const { logout, clearAuthError, clearSignupMessage } = authSlice.actions;

// // Selectors
// export const selectUserInfo = (state) => state.auth.userInfo;
// export const selectAuthLoading = (state) => state.auth.loading;
// export const selectAuthError = (state) => state.auth.error;

// export default authSlice.reducer;
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  signupUser as apiSignupUser,
  loginUser as apiLoginUser,
  getMyProfile,
} from '../../Common/services/httpservice';

// Helper to get user info from localStorage
const getUserInfoFromStorage = () => {
  try {
    const userInfoString = localStorage.getItem('userInfo');
    return userInfoString ? JSON.parse(userInfoString) : null;
  } catch (error) {
    console.error('Error parsing userInfo from localStorage', error);
    localStorage.removeItem('userInfo');
    return null;
  }
};

// Async thunk for user signup
export const signupUser = createAsyncThunk(
  'auth/signupUser',
  async (userData, { rejectWithValue }) => {
    try {
      const data = await apiSignupUser(userData);
      if (data && data.token) {
        localStorage.setItem('accessToken', data.token);
        localStorage.setItem('userInfo', JSON.stringify(data.user || data));
      }
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'An unknown error occurred during signup.');
    }
  }
);

// Async thunk for user login
export const loginUser = createAsyncThunk(
  'auth/loginUser',
  async (loginData, { rejectWithValue }) => {
    try {
      const tokenData = await apiLoginUser(loginData);

      if (tokenData && tokenData.access) {
        localStorage.setItem('accessToken', tokenData.access);
        if (tokenData.refresh) {
          localStorage.setItem('refreshToken', tokenData.refresh);
        }

        const userProfile = await getMyProfile();
        localStorage.setItem('userInfo', JSON.stringify(userProfile));
        return userProfile;
      } else {
        return rejectWithValue('Login failed: No access token received.');
      }
    } catch (error) {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('userInfo');
      return rejectWithValue(error.message || 'An unknown error occurred during login.');
    }
  }
);

const initialState = {
  userInfo: getUserInfoFromStorage(),
  loading: false,
  error: null,
  signupMessage: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      localStorage.removeItem('userInfo');
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      state.userInfo = null;
      state.loading = false;
      state.error = null;
    },
    clearAuthError: (state) => {
      state.error = null;
    },
    clearSignupMessage: (state) => {
      state.signupMessage = null;
    },
    updateUserInfo: (state, action) => {
      state.userInfo = {
        ...state.userInfo,
        ...action.payload,
      };
      localStorage.setItem('userInfo', JSON.stringify(state.userInfo)); // sync update to localStorage
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(signupUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(signupUser.fulfilled, (state, action) => {
        state.loading = false;
        state.userInfo = action.payload.user;
        state.signupMessage = action.payload.message;
        state.error = null;
      })
      .addCase(signupUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.userInfo = null;
      })
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.userInfo = action.payload;
        state.error = null;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.userInfo = null;
      });
  },
});

export const {
  logout,
  clearAuthError,
  clearSignupMessage,
  updateUserInfo,
} = authSlice.actions;

// Selectors
export const selectUserInfo = (state) => state.auth.userInfo;
export const selectAuthLoading = (state) => state.auth.loading;
export const selectAuthError = (state) => state.auth.error;

export default authSlice.reducer;